import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface MenuState {
  drawerOpen: boolean;
  activeItem: string;
}

const initialState: MenuState = {
  drawerOpen: false,
  activeItem: '',
};

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleDrawer(state) {
      state.drawerOpen = !state.drawerOpen;
    },
    setDrawerOpen(state, action: PayloadAction<boolean>) {
      state.drawerOpen = action.payload;
    },
    setActiveItem(state, action: PayloadAction<string>) {
      state.activeItem = action.payload;
    },
  },
});

export const { toggleDrawer, setDrawerOpen, setActiveItem } = menuSlice.actions;
export default menuSlice.reducer;
